// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cancellation-banner__requester-name{font-weight:bold}`, "",{"version":3,"sources":["webpack://./app/new-components/OpAppScaffold/components/CancellationBanner.scss"],"names":[],"mappings":"AACE,qCACE,gBAAA","sourcesContent":[".cancellation-banner {\n  &__requester-name {\n    font-weight: bold;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
